import slice from '../reducer/slice';

import { BBox } from '@turf/helpers';

const { setStationsFitBounds } = slice.actions;

const operation = (fitBounds: BBox) => setStationsFitBounds(fitBounds);

export default operation;
